import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';

const formatContacts = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        date: item.date && moment(item.date),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchContacts,
    create: createContact,
    update: updateContact,
    delete: deleteContacts
} = createCrudActions('CONTACT', "Contacto", formatContacts);
